import { createContext } from 'react';
import { IntegratedDexResultsReturn } from './use-integrated-dex-results';

export const DexResultsContext = createContext<IntegratedDexResultsReturn | undefined>(undefined);
